const setSession = (session) => {
  return {
    type: "SET_SESSION",
    session
  }
}

const notificationSaleEcommerce = (id_notification) => {
  return {
    type: "NOTIFICATION_SALE_ECOMMERCE",
    id_notification
  }
}

export {
  setSession, notificationSaleEcommerce
}